import { BodyText, InlineLink } from '@utilitywarehouse/hearth-react';
import { TickCircleMediumIcon } from '@utilitywarehouse/hearth-react-icons';
import clsx from 'clsx';

interface KeepInTouchSectionProps {
  hasChangedPreferences: boolean;
  marketingAccepted: boolean;
  isLoading: boolean;
  onDialogOpen: () => void;
}

interface OpenDialogLinkProps {
  isLoading: boolean;
  onClick: () => void;
}

const OpenDialogLink = ({ isLoading, onClick }: OpenDialogLinkProps) => (
  <InlineLink
    className={clsx({ saveForLater__letUsKnowDisabled: isLoading })}
    onClick={onClick}
  >
    let us know
  </InlineLink>
);

const KeepInTouchSection = ({
  hasChangedPreferences,
  marketingAccepted,
  isLoading,
  onDialogOpen,
}: KeepInTouchSectionProps) => {
  const handleDialogOpen = () => {
    if (isLoading) {
      return;
    }

    onDialogOpen();
  };

  const renderText = () => {
    if (marketingAccepted) {
      return (
        <BodyText>
          We'll let you know if our tariffs change in price, and will keep in
          touch about how you can save even more time and money on your bills.
          You can opt out at any time, but if you'd rather not hear from us,
          please{' '}
          <OpenDialogLink onClick={handleDialogOpen} isLoading={isLoading} />.
          This choice applies to hearing from us before you become a UW
          customer. You'll be asked about your communication preferences again
          when you sign up.
        </BodyText>
      );
    }

    return (
      <BodyText>
        If you’d like to opt back in, please{' '}
        <OpenDialogLink onClick={handleDialogOpen} isLoading={isLoading} />.
        This choice applies to hearing from us before you become a UW customer.
        You'll be asked about your communication preferences again when you sign
        up.
      </BodyText>
    );
  };

  return (
    <div>
      {hasChangedPreferences && (
        <BodyText className="saveForLater__savedContactPrefs">
          <TickCircleMediumIcon />
          We've saved your contact preferences
        </BodyText>
      )}
      {renderText()}
    </div>
  );
};

export { KeepInTouchSection };
